import pixPropertyTabGuard from '@/guards/pixPropertyTab.guard.js';
import pixPropertyManagementGuard from '@/guards/pixPropertyManagement.guard.js';
import genericTabsPathConst from '@/consts/genericTabsPath.const';
import genericTabConst from '@/consts/genericTab.const.js';

const propertyRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "pixDashboard" */ '@/pages/dashboard/pixDashboard.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/projectManagement',
    component: () => import(/* webpackChunkName: "projectManagement" */ '@/pages/projectManagement/projectManagement.vue'),
    props: true,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '/projectManagement/:jobRowId',
        name: 'mandateManagement',
        component: () => import(/* webpackChunkName: "pixMandate" */ '@/pages/projectManagement/pixMandate/pixMandate.vue'),
        props: true,
        meta: {
          auth: true,
        },
      },
      {
        path: '/projectManagement/:jobRowId/:rowId',
        component: () => import(/* webpackChunkName: "pixProperty" */ '@/pages/projectManagement/pixProperty/pixProperty.vue'),
        props: true,
        meta: {
          auth: true,
        },
        beforeEnter: pixPropertyManagementGuard,
        children: [
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.SCOPE]}`,
            name: 'propertyManagementScope',
            component: () => import(/* webpackChunkName: "pixPropertyScope" */ '@/pages/projectManagement/pixProperty/pixPropertyScope/pixPropertyScope.vue'),
            meta: { tabId: genericTabConst.SCOPE },
            beforeEnter: pixPropertyTabGuard(genericTabConst.SCOPE),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.PROPERTY]}`,
            name: 'propertyManagementProperty',
            component: () => import(/* webpackChunkName: "pixPropertyPropertyDetails" */ '@/pages/projectManagement/pixProperty/pixPropertyPropertyDetails/pixPropertyPropertyDetails.vue'),
            meta: { tabId: genericTabConst.PROPERTY },
            beforeEnter: pixPropertyTabGuard(genericTabConst.PROPERTY),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.PUBLIC]}`,
            name: 'propertyManagementPublic',
            component: () => import(/* webpackChunkName: "pixPropertyPublic" */ '@/pages/projectManagement/pixProperty/pixPropertyPublic/pixPropertyPublic.vue'),
            meta: { tabId: genericTabConst.PUBLIC },
            beforeEnter: pixPropertyTabGuard(genericTabConst.PUBLIC),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.MARKET_RENT]}`,
            name: 'propertyManagementRevenueUnits',
            component: () => import(/* webpackChunkName: "pixPropertyRevenueUnits" */ '@/pages/projectManagement/pixProperty/pixPropertyRevenueUnits/pixPropertyRevenueUnits.vue'),
            meta: { tabId: genericTabConst.MARKET_RENT },
            beforeEnter: pixPropertyTabGuard(genericTabConst.MARKET_RENT),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.SALES_INFO]}`,
            name: 'propertyManagementSalesInfo',
            component: () => import(/* webpackChunkName: "pixPropertySalesInfo" */ '@/pages/projectManagement/pixProperty/pixPropertySalesInfo/pixPropertySalesInfo.vue'),
            meta: { tabId: genericTabConst.SALES_INFO },
            beforeEnter: pixPropertyTabGuard(genericTabConst.SALES_INFO),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.LEASE_COMPS]}`,
            name: 'propertyManagementLeaseComparable',
            component: () => import(/* webpackChunkName: "pixPropertyComparableContainer" */ '@/pages/projectManagement/pixProperty/pixPropertyComparable/pixPropertyComparableContainer.vue'),
            meta: { tabId: genericTabConst.LEASE_COMPS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.LEASE_COMPS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.RENT_SURVEY_COMPS]}`,
            name: 'propertyManagementRentSurveyComparable',
            component: () => import(/* webpackChunkName: "pixPropertyComparableContainer" */ '@/pages/projectManagement/pixProperty/pixPropertyComparable/pixPropertyComparableContainer.vue'),
            meta: { tabId: genericTabConst.RENT_SURVEY_COMPS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.RENT_SURVEY_COMPS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.SALES_COMPS]}`,
            name: 'propertyManagementSalesComparable',
            component: () => import(/* webpackChunkName: "pixPropertyComparableContainer" */ '@/pages/projectManagement/pixProperty/pixPropertyComparable/pixPropertyComparableContainer.vue'),
            meta: { tabId: genericTabConst.SALES_COMPS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.SALES_COMPS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.LAND_COMPS]}`,
            name: 'propertyManagementLandComparable',
            component: () => import(/* webpackChunkName: "pixPropertyComparableContainer" */ '@/pages/projectManagement/pixProperty/pixPropertyComparable/pixPropertyComparableContainer.vue'),
            meta: { tabId: genericTabConst.LAND_COMPS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.LAND_COMPS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.IE_COMPS]}`,
            name: 'propertyManagementIEComparable',
            component: () => import(/* webpackChunkName: "pixPropertyComparableContainer" */ '@/pages/projectManagement/pixProperty/pixPropertyComparable/pixPropertyComparableContainer.vue'),
            meta: { tabId: genericTabConst.IE_COMPS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.IE_COMPS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.REPORT]}`,
            name: 'propertyManagementReport',
            component: () => import(/* webpackChunkName: "pixPropertyReport" */ '@/pages/projectManagement/pixProperty/pixPropertyReport/pixPropertyReport.vue'),
            meta: { tabId: genericTabConst.REPORT },
            beforeEnter: pixPropertyTabGuard(genericTabConst.REPORT),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.DOCUMENTS]}`,
            name: 'propertyManagementDocument',
            component: () => import(/* webpackChunkName: "pixPropertyDocuments" */ '@/pages/projectManagement/pixProperty/pixPropertyDocuments/pixPropertyDocuments.vue'),
            meta: { tabId: genericTabConst.DOCUMENTS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.DOCUMENTS),
          },
          {
            path: `/projectManagement/:jobRowId/:rowId/${genericTabsPathConst[genericTabConst.CALCULATIONS]}`,
            name: 'propertyManagementCalculations',
            component: () => import(/* webpackChunkName: "pixPropertyCalculations" */ '@/pages/projectManagement/pixProperty/pixPropertyCalculations/pixPropertyCalculations.vue'),
            meta: { tabId: genericTabConst.CALCULATIONS },
            beforeEnter: pixPropertyTabGuard(genericTabConst.CALCULATIONS),
          },
          { path: '*', redirect: '/projectManagement/:jobRowId/:rowId' },
        ],
      },
      { path: '', name: 'projectManagement', component: () => import(/* webpackChunkName: "pixMandate" */ '@/pages/projectManagement/pixMandate/pixMandate.vue') },
    ],
  },
];

export default propertyRoutes;
